












import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AppCardLayout extends Vue {
  @Prop({ type: String, default: 'left' })
  readonly sidebarPosition: 'left' | 'right';

  @Prop({ type: Boolean, default: false })
  readonly isNoSlider: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/layouts/cardlayouts/CardLayout/AppCardLayout.vue